import React, { useState, useEffect } from "react";
import { PRODUCT_FAMILY_DETAILS_LISTING_COLUMNS } from "../../../utils/constant";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  TableSortLabel,
  Box,
  IconButton
} from "@mui/material";
import RecordNotFound from "../../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_FAMILY_VALIDATIONS } from "../../../utils/Validation";
import AddProductFamily from "./AddProductFamily";
import Add from "@mui/icons-material/Add";
import { visuallyHidden } from "@mui/utils";
import {
  onUpdateProductFamilyService,
  ProductFamilyChangeStatusService,
  onAddProductFamilyService,
} from "../../../services/MasterDataManagementService";
import useGlobalState from "../../../Context";
import EditIcon from "@mui/icons-material/Edit";

const FamilyList = ({
  totalElements,
  onSearch,
  handleTableChanges,
  setLoading,
  showNotification,
  categoryList,
  fetchCategoryList,
  fetchProductFamilyList,
  productFamilyList,
  setProductFamilyList,
  noRecord,
}) => {
  const [searchedRows, setSearchedRows] = useState(productFamilyList);
  const [familyNameSearch, setFamilyNameSearch] = useState("");
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddFamilyDialog, setOpenAddFamilyDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [selected, setSelected] = useState([]);
  const [catNameForFamily, setCatNameForFamily] = useState("");
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [productFamilyId, setProductFamilyId] = useState("");
  const [sortValue, setSortValue] = useState('ASC');
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("productFamilyName");
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const [searchValue_, setsearchValue_] = useState(null);
  const loginUserId = auth.ldapParam.userId;
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserId,
    active: 1,
  });

  const formOption = {
    resolver: yupResolver(ADD_FAMILY_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    setValue
  } = useForm(formOption);

  useEffect(() => {
    reset(formData);
  }, [openAddFamilyDialog]);

  useEffect(() => {
    
    setSearchedRows(productFamilyList);
  }, [familyNameSearch, productFamilyList]);

  const searchText = async (e) => {
    setSearchValue(e.target.value);
    setFamilyNameSearch("");
    e.target.value === "" ? setClearSearch(false) : setClearSearch(true);
    if (e.target.value === "") {
      onclickClear();
    }
  };

  const handleClickOpenFamilyDialog = () => {
    setOpenAddFamilyDialog(true);
    fetchCategoryList();
  };
  const handleCloseFamilyDialog = () => {
    setOpenAddFamilyDialog(false);
    setIsEditMode(false);
    setIsUpdateButton(true);
    setFormData({});
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
       const requestBody = {
        status: true,
        pageNumber: 0,
        pageSize:   rowsPerPage ?? 10,
       search: searchValue && searchValue.trim(),
      };
      setsearchValue_(searchValue)
      setIsSearchBtnClick(true);
      setSelected([]);
      setDisbaleUpdateButton(true)
      await onSearch(requestBody, searchValue && searchValue.trim());
      setPage(0);
      setMaxPage(0);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
    // setSearchwith(type);
    setFamilyNameSearch(searchValue && searchValue.trim());
  };

  const onclickClear = async () => {
    const paginationData= {
      pageNumber:  0,
      pageSize:  rowsPerPage ?? 10,
    };
    setSelected([]);
    setsearchValue_(null)
    setDisbaleUpdateButton(true)
    await fetchProductFamilyList("productFamilyName", false,null,null,paginationData);

    setSearchValue("");
    setPage(0);
    setMaxPage(0);
    // setRowsPerPage(10);
    setClearSearch(false);
    setFamilyNameSearch(""); 
    setIsSearchBtnClick(false);
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(paginationValues, false, sortValue, orderBy,searchValue_);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
     
      await handleTableChanges(paginationValues, true, sortValue, orderBy,searchValue_);
    }
    setPage(newPage);
  };

  const onAddProductFamilySubmit = async (data) => {
    try {
      let obj = {
        categoryId: parseInt(data.categoryId),
        categoryName: catNameForFamily && catNameForFamily.trim(),
        productFamilyName: data.productFamilyName && data.productFamilyName.trim(),
        productFamilyId: productFamilyId ? productFamilyId : 0,
        modifiedOn: formValues.createdOn,
        modifiedBy: formValues.createdBy,
        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        active: formValues.active ? true : false,
        productCatFamilyMappingId: data.productCatFamilyMappingId ?? null,
      };
      const res = !isEditMode
        ? await onAddProductFamilyService(obj)
        : await onUpdateProductFamilyService(obj);
      if (res.statusCode == "6") {
        const newFamilyList = [...productFamilyList];
        const index = newFamilyList.findIndex(
          (x) => x.productFamilyId === productFamilyId
        );
        newFamilyList[index] = { ...productFamilyList[index], ...obj };
        setProductFamilyList(newFamilyList);
        handleCloseFamilyDialog(false);
        setIsUpdateButton(true);
        setSelected([]); setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
        onclickClear()
        // if (!isEditMode) {
        //   setPage(0);
        //   setMaxPage(0);
          
        //   const timer = setTimeout(async () => {
        //     await fetchProductFamilyList("productFamilyName", true);
        //   }, 1000);
        //   return () => clearTimeout(timer);
         
        // }
      } else {
        handleCloseFamilyDialog(false);
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      handleCloseFamilyDialog(false);
      showNotification("Error", "Faild to add product family", "error");
      throw err;
    }
  };

  const handleClickEditProductFamily = (item) => {
    if (item) {
      reset(item);
    }
    fetchCategoryList();
    setOpenAddFamilyDialog(true);
    setIsEditMode(true);
    setCatNameForFamily(item.categoryName);
    setProductFamilyId(item.productFamilyId);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item.createdBy ? item.createdBy : 1,
      active: item?.active ? item.active : 0,
    });
    setFormData({ ...item });
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - productFamilyList.length)
      : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = productFamilyList.map((currentRow) => {
      if (currentRow.productCatFamilyMappingId === id) {
        return {
          ...currentRow,
          active: event.target.checked,
        };
      }
      return currentRow;
    });
    setProductFamilyList(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = productFamilyList.find(
        (record) => record.productCatFamilyMappingId === itemId
      );
      if (tempItem) {
        resultRecords.push({
          active: tempItem.active,
          productFamilyId: tempItem.productCatFamilyMappingId,
        });
      }       
    });
    try {
      const res = await ProductFamilyChangeStatusService(resultRecords);
      if (res.statusCode == "6") {
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const paginationData= {
      pageNumber: page ? page : 0,
      pageSize:  rowsPerPage ? rowsPerPage :  10,
    };
    setSelected([]);
    setDisbaleUpdateButton(true)
    fetchProductFamilyList(property, isAsc,'null',searchValue_ && searchValue_.trim(),paginationData);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
   
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0 }} display="flex">
          <Grid item xs={6} md={4}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93"}}
              variant="h6"
            >
              Family Listing ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={6} md={8}>
            <Typography align="right">
              <div className="searchContainer">
             
                <input
                  type="text"
                  placeholder="By Family Name"
                  onChange={searchText}
                  className="searchInput2"
                  value={searchValue}
                />
                 <IconButton disabled={searchValue === ""} className={searchValue === "" ? 'searchIcon':'filPrimaryColor searchIcon'}>
                <SearchIcon
                 // className="searchIcon"
                  onClick={() => searchOnClick("productFamilyName")}
                />
                </IconButton>
                {clearSearch && (
                  <ClearIcon
                    sx={{ fontSize: "22px", color: "red" }}
                    className="brandSearchClear"
                    onClick={onclickClear}
                  />
                )}
              </div>
              <Tooltip title="Add Family">
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenFamilyDialog();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}
                >
                  Add Family
                </Button>
              </Tooltip>
              <Tooltip title="Update Family Status">
                <span>
                <Button
                  variant="contained"
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  onClick={onChangeStatusSubmit}
                  disabled={disableUpdateButton}
                >
                  Status Update
                  {selected.length !== 0 &&
                    ` (${Object.keys(selected).length})`}
                </Button>
                </span>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={4} sx={{ mt: 2 }}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    rowCount={searchedRows && searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(
                            row.productCatFamilyMappingId
                          );
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              key={index}
                            >
                              <TableCell size="small" key={"productFamilyName"}>
                                {row["productFamilyName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"categoryName"}>
                                {row["categoryName"] ?? "-"}
                              </TableCell>
                              <TableCell align="left">
                                {" "}
                                <Checkbox
                                  color="primary"
                                  // checked={row.active}
                                  checked={(isItemSelected, row.active)}
                                  classes={{root: 'custom-checkbox-root'}}
                                  onClick={(event) =>
                                    handleActiveChange(
                                      event,
                                      row.productCatFamilyMappingId
                                    )
                                  }
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <EditIcon
                                  sx={{ fontSize: "20px", cursor: "pointer",color:'#567aac', height: "18px", 
                                  width: "18px"  }}
                                  onClick={() => handleClickEditProductFamily(row)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}
                        >
                          <TableCell colSpan={4} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={4}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={4} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddProductFamily
              openDialog={openAddFamilyDialog}
              handleClose={handleCloseFamilyDialog}
              register={register}
              setError={setError}
              handleSubmit={handleSubmit}
              errors={errors}
              categoryList={categoryList}
              onAddProductFamilySubmit={onAddProductFamilySubmit}
              setCatNameForFamily={setCatNameForFamily}
              formData={formData}
              isEditMode={isEditMode}
              isUpdateButton={isUpdateButton}
              setIsUpdateButton={setIsUpdateButton}
              setValue = {setValue}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default FamilyList;

function EnhancedTableHead({ onRequestSort, order, orderBy }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow key={"1"}>
        {PRODUCT_FAMILY_DETAILS_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.productCatFamilyMappingId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" || headCell.id === "active") && true
              }
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
